<template>
  <div class="app-container" ref="body">
    <div class="app-body">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" style="padding-bottom:5rem;" class="home-items-wrap">
        <h4 class="title">培训项目</h4>
        <van-list
          v-model="isLoading"
          :finished="finished"
          :finished-text="finishedtext"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
          class="home-items"
        >
          <template v-for="item in list">
            <div :key="item.id" class="item">
              <div v-if="item.pic" class="imgs" :style="imageStyle2">
                <img :src="imgPath(item.pic)">
              </div>
              <div class="detail">
                <div class="tit">{{ item.title }}</div>
                <div class="con ellipsis-2">{{ item.content }}</div>
                <div class="btns">
                  <van-tag v-if="!item.enabled" color="#ccc" text-color="#fff">报名关闭</van-tag>
                  <van-button v-else type="primary" size="mini" @click="doSignup(item)">立即报名</van-button>
                  <van-button type="info" size="mini" plain style="margin-left:2rem;" @click="showItem(item)">查看详情</van-button>
                </div>
              </div>
            </div>
          </template>
        </van-list>
        <van-empty v-if="!list || !list.length" image="error" description="还没有培训项目" />
      </van-pull-refresh>
    </div>
    <AppFooter />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tools from '@/utils/tools';
import mixin from '../mixin';
import AppFooter from '../app-footer.vue';
export default {
  components: {
    AppFooter
  },
  mixins: [tools, mixin],
  data() {
    return {
      isLoading: false,
      finished: false,
      count: 0,
      page: 1,
      list: [],
      error: false,
      w: 0
    }
  },
  computed: {
    ...mapGetters([]),
    imageStyle() {
      let style = {};
      if (this.w) {
        style = {height: (this.w * 0.8) + 'px'};
      }
      return style;
    },
    imageStyle2() {
      let style = {}
      if (this.w) {
        let h = this.w * 0.618 * 0.26;
        style = {height: h + 'px'};
      }
      return style;
    },
  },
  watch: {
  },
  created () {
    // resize
    let resizeId;
    window.addEventListener('resize', () => {
      clearTimeout(resizeId);
      resizeId = setTimeout(this.getImgW, 300);
    });

    this.loadData();
  },
  activated() {
    if (!this.w) {
      this.getImgW();
    }
  },
  mounted () {
    this.page = 1;
  },
  methods: {
    loadData(callback) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.doPost({
        url: 'site/home/items',
        data: {pageCurrent: this.page},
        okcb: (json) => {
          if (callback && callback instanceof Function) {
            callback(json);
          } else {
            this.list = json.list;
            this.page = json.pageNumber;
          }
        },
        cb: () => {
          this.$nextTick(() => this.isLoading = false);
        },
        errcb: () => {
          this.error = true;
        }
      });
    },
    getImgW() {
      this.$nextTick(() => {
        this.w = this.$refs.body && this.$refs.body.offsetWidth;
      });
    },
    onRefresh() {
      this.isLoading = false;
      this.page = 1;
      this.loadData((json) => {
        this.list = json.list;
        this.page = json.pageNumber;
        this.$toast('刷新成功');
      });
    },
    onLoad() {
      // console.log('load.....')
      this.isLoading = false;
      this.finished = false;
      this.page = this.list.length ? this.page + 1 : 1;
      this.loadData((json) => {
        this.list = this.list.concat(json.list);
        this.page = json.pageNumber;

        // 如果已加载完
        if (!json.totalRow || json.totalPage <= json.pageNumber) {
          this.finished = true;
        }
      });
    },
    doSignup(item) {
      this.$router.push('/signup/'+ item.id);
    },
    showItem(item) {
      this.$router.push('/item/'+ item.id);
    }
  }
}
</script>
<style lang="less" scoped>
.app-body {
  margin-bottom:5.2rem;
}
.home-user {
  .flex-center-v();
  margin:1rem;
  padding:1rem;
  background-color:#fff;
  border-radius:1rem;
  .shadow_black(0 0 10px 0, .05);
  .headpic {
    margin-right:2rem;
  }
  .count {
    color:green;
    .fontsize(2rem);
  }
}
.home-items-wrap {
  h4.title {
    margin-bottom:.25rem;
    padding:0 1rem;
    color:#888;
  }
}
.home-items {
  padding:0 1rem 2rem;
  .item {
    .flex();
    margin-bottom:1rem;
    background-color:#fff;
    border-radius:1rem;
    .shadow_black(0 0 10px 0, .05);
    .imgs {
      padding:.5rem;
      margin-right:1rem;
      width: 26%;
      flex-shrink: 0;
      img {
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .detail {
      padding:.5rem;
      .tit {
        .fontsize(1.2rem);
      }
      .con {
        margin-top:.25rem;
        color:#888;
      }
      .btns {
        margin-top:.5rem;
      }
    }
  }
}
</style>